export default __webpack_public_path__ + "images/RP.dcde872.png";